import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Row, Breadcrumb, Form } from 'antd';
import { Link } from 'react-router-dom';
import allBillersRoute from 'modules/AllBillers/route';
import CallbackModal from 'components/CallbackModal';

import text from './ServiceCreate.page.translation';
import ServiceCreateForm from '../../components/ServiceForm/Service.form.component';

import './ServiceCreate.style.less';

const FormServiceCreate = Form.create()(ServiceCreateForm);

class ServiceCreate extends Component {
  constructor(props) {
    super(props);

    this.state = {
      modalNotification: false,
      isSuccess: false,
      serviceId: '',
      remarksInactive: false,
      seriesResult: [],
    };
  }
  getTitle = () => (this.props.match.params.id ? 'editTitle' : 'createTitle');

  componentDidMount() {
    const { match, service } = this.props;
    const defaultParam = `page_num=1&page_size=50&name=${
      service.default_form ? service.default_form.name : ''
    }`;

    if (match.params.id && service.id !== match.params.id) {
      const { id } = match.params;
      this.props.getService(id);
    }

    this.props.getListAggregator();
    this.props.getListForm(defaultParam);
  }

  onCloseModalNotification = () => {
    const { isSuccess, serviceId } = this.state;
    if (isSuccess) {
      this.goToServiceDetail(serviceId);
    } else {
      this.setState({
        modalNotification: false,
        isSuccess: false,
      });
    }
  };

  goToServiceDetail = id => {
    this.props.history.push(`${allBillersRoute.SERVICES}/${id}`);
  };

  callbackModalNotification = (id, status, type, result) => {
    const seriesResult = result;
    seriesResult[0].info = this.getDescriptionNotification(type);

    this._setRemarksInactive(false);
    this.setState({
      modalNotification: true,
      isSuccess: status,
      serviceId: id,
      seriesResult,
    });
  };

  getDescriptionNotification = type => {
    const {
      intl: { formatMessage },
    } = this.props;

    let result = '';
    switch (type) {
      case 'archive':
        result = formatMessage(text.confirmation.message.archive);
        break;
      case 'inactive':
        result = formatMessage(text.confirmation.message.inactive);
        break;
      default:
        break;
    }

    return result;
  };

  _onCreateSuccess = (id, status, _type, seriesResult) => {
    this.setState({
      modalNotification: true,
      isSuccess: status,
      serviceId: id,
      seriesResult,
    });
  };

  onSubmit = (params, isArchive, isSyncConsent) => {
    if (this.props.match.params.id) {
      this.props.updateService(
        this.props.match.params.id,
        params,
        isArchive,
        isSyncConsent,
        this.callbackModalNotification,
      );
    } else {
      this.props.createNewService(params, isSyncConsent, this._onCreateSuccess);
    }
  };

  renderBreadCrumb = () => {
    const {
      intl: { formatMessage },
    } = this.props;
    return (
      <Row className="breadcrumb-wrapper">
        <Breadcrumb>
          <Breadcrumb.Item>
            <Link to="/">{formatMessage(text.home)}</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <Link to={allBillersRoute.SERVICES}>
              {formatMessage(text.serviceTitle)}
            </Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            {formatMessage(text[this.getTitle()])}
          </Breadcrumb.Item>
        </Breadcrumb>
      </Row>
    );
  };

  _setRemarksInactive = value => {
    this.setState({ remarksInactive: value });
  };

  renderForm() {
    const {
      getListForm,
      getListAggregator,
      listAggregator,
      listForm,
      intl,
      match,
      service,
      loading,
    } = this.props;
    // don't render if data not ready
    const renderWhenReady = !match.params.id || service.id;
    return (
      renderWhenReady && (
        <FormServiceCreate
          getListForm={getListForm}
          listForm={listForm}
          getListAggregator={getListAggregator}
          listAggregator={listAggregator}
          intl={intl}
          edit={match.params.id}
          service={service}
          onSubmit={this.onSubmit}
          loading={loading}
          remarksInactive={this.state.remarksInactive}
          setRemarksInactive={this._setRemarksInactive}
        />
      )
    );
  }

  render() {
    const {
      intl: { formatMessage },
    } = this.props;
    const { isSuccess, modalNotification, seriesResult } = this.state;

    return (
      <div className="main-content service-create">
        {this.renderBreadCrumb()}
        <div className="white-box-wrapper">
          <span className="title">{formatMessage(text[this.getTitle()])}</span>
          <div className="divider" />
          <div id="form-new-service" className="form-wrapper">
            {this.renderForm()}
          </div>
        </div>
        <CallbackModal
          modalVisible={modalNotification}
          type={isSuccess ? 'success' : 'failed'}
          onClose={this.onCloseModalNotification}
          btnText="Close"
          seriesResult={seriesResult}
        />
      </div>
    );
  }
}

ServiceCreate.propTypes = {
  intl: PropTypes.object,
  match: PropTypes.object,
  service: PropTypes.object,
  getListAggregator: PropTypes.func,
  listAggregator: PropTypes.array,
  getListForm: PropTypes.func,
  listForm: PropTypes.array,
  getService: PropTypes.func,
  updateService: PropTypes.func,
  createNewService: PropTypes.func,
  history: PropTypes.object,
  loading: PropTypes.bool,
};

export default ServiceCreate;
